import { Button } from "@/components/ui/button";

type AuthStep = "welcome" | "signIn" | "signUp" | "resetPassword";

interface WelcomeStepProps {
  onSwitchStep: (step: AuthStep) => void;
  onClose: () => void;
}

export function WelcomeStep({ onSwitchStep, onClose }: WelcomeStepProps) {
  return (
    <div>
      <p className="mb-6">Чтобы начать игру, необходимо создать аккаунт.</p>

      <div className="flex flex-col gap-3">
        <Button onClick={() => onSwitchStep("signUp")} className="w-full">
          Создать аккаунт
        </Button>
        <Button
          variant="secondary"
          onClick={() => onSwitchStep("signIn")}
          className="w-full ml-0"
        >
          Войти
        </Button>
      </div>
    </div>
  );
}
